import { forwardRef, InputHTMLAttributes } from 'react';

import { ErrorMessage } from './ErrorMessage';

interface IDateInputProps
  extends Omit<
    InputHTMLAttributes<HTMLInputElement>,
    'type' | 'inputMode' | 'defaultValue'
  > {
  readonly label: string;
  readonly errors?: ReadonlyArray<string>;
}

export const DateInput = forwardRef<HTMLInputElement, IDateInputProps>(
  function DateInput(props, ref) {
    const {
      errors = [],
      label,
      required,
      readOnly,
      disabled,
      ...inputProps
    } = props;

    return (
      <div
        className="pmi_web_inputs__wrapper"
        data-disabled={readOnly || disabled}
      >
        <label
          className={'pmi_web_inputs__inputlabel'}
          data-errors={errors.length > 0}
        >
          <input
            {...inputProps}
            readOnly={readOnly}
            disabled={disabled}
            type="date"
            ref={ref}
            data-required={required}
          />
          <span>{label}</span>
        </label>
        {errors.map(error => (
          <ErrorMessage key={error} message={error} />
        ))}
      </div>
    );
  },
);
